var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _vm.quotaLeave.length <= 0
          ? _c(
              "div",
              {
                staticClass: "d-flex align-items-center justify-content-center",
                staticStyle: { height: "250px" }
              },
              [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center" },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/icon/info.png"),
                        width: "60",
                        height: "60"
                      }
                    }),
                    _vm._v(" "),
                    _c("h6", [_vm._v("Data is empty")]),
                    _vm._v(" "),
                    _c("h6", [_vm._v("Your leave type has not been setup")])
                  ]
                )
              ]
            )
          : _vm._l(_vm.quotaLeave, function(item) {
              return _c(
                "div",
                { key: item.id, staticClass: "mt-3" },
                [
                  _c("label", { staticClass: "bold w-50 mb-0 text-truncate" }, [
                    _c("img", {
                      attrs: { src: item.icon_url, width: "20", height: "20" }
                    }),
                    _vm._v("\n        " + _vm._s(item.name) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c("label", { staticClass: "float-right" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          "(" +
                            _vm.$moment(item.start_date).format("DD MMM YYYY") +
                            "\n        -\n        " +
                            _vm.$moment(item.end_date).format("DD MMM YYYY") +
                            ")"
                        ) +
                        "\n      "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-progress",
                    {
                      staticClass: "mt-1",
                      attrs: { max: item.quota === 0 ? 1 : item.quota }
                    },
                    [
                      _c(
                        "b-progress-bar",
                        {
                          staticStyle: {
                            "background-color": "#2487E1 !important"
                          },
                          attrs: { value: item.usage, variant: "primary" }
                        },
                        [
                          _c(
                            "span",
                            {
                              class:
                                (item.usage / item.quota) * 100 > 5
                                  ? "label-used"
                                  : "label-used-null",
                              staticStyle: {
                                position: "absolute",
                                "margin-left": "5px"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Used: " +
                                  _vm._s(item.usage) +
                                  "\n          "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-progress-bar",
                        {
                          staticStyle: {
                            "background-color": "#D3D3D3 !important"
                          },
                          attrs: {
                            value:
                              item.quota === 0 ? 1 : item.quota - item.usage,
                            variant: "secondary"
                          }
                        },
                        [
                          _c(
                            "span",
                            {
                              class:
                                ((item.quota - item.usage) / item.quota) * 100 >
                                6
                                  ? "label-remaining"
                                  : "label-remaining-null",
                              staticStyle: {
                                position: "absolute",
                                right: "15px",
                                "margin-right": "5px"
                              }
                            },
                            [
                              _vm._v(
                                "\n            Remaining: " +
                                  _vm._s(item.quota - item.usage) +
                                  "\n          "
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
        _vm._v(" "),
        _c("div")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4bcdc74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4bcdc74","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/widget/widget-card/jQuotaLeaveWidget.vue
// module id = null
// module chunks = 